import {axiosInstance} from '../../network/apis/index';

const followedCompanies = async (id ) =>{
    return await axiosInstance.put(`/candidate/companies/${id}/follow` );
}

export default {
    followedCompanies
};